import { defineMessages } from 'react-intl'

export default defineMessages({
  createToolbar: {
    id: 'OrganizationToolbarsPage.createToolbar',
    defaultMessage: 'Add Client'
  },
  title: {
    id: 'OrganizationToolbarsPage.Description',
    defaultMessage: 'Clients'
  },
  errorTitle: {
    id: 'UnrecoverableError.Title',
    defaultMessage: 'Something went wrong...'
  },
  errorMessage: {
    id: 'UnrecoverableError.Message',
    defaultMessage: "It's not you, it's us. There was a problem with the system which caused your request to fail."
  },
  loading: {
    id: 'OrganizationToolbarsPage.Loading',
    defaultMessage: 'Loading...'
  },
  deleting: {
    id: 'OrganizationToolbarsPage.Deleting',
    defaultMessage: 'Deleting Client...'
  },
  updating: {
    id: 'OrganizationToolbarsPage.Updating',
    defaultMessage: 'Updating Client...'
  },
  adding: {
    id: 'OrganizationToolbarsPage.Adding',
    defaultMessage: 'Creating Client...'
  }
})
